import { Component } from '@angular/core';
import { FontToggleComponent } from '../font-toggle/font-toggle.component';

@Component({
  selector: 'app-profile-header',
  imports: [FontToggleComponent],
  templateUrl: './profile-header.component.html',
  styleUrl: './profile-header.component.scss',
})
export class ProfileHeaderComponent {}
